export default __webpack_public_path__ + "static/media/edit.9af79e65.svg";